import {
  CardPage,
  getTranslatedText,
  HeaderTag,
  withErrorBoundary,
  AccessControl
} from '@nile/components';
import { RMMClient, useCachedQuery } from '@nile/graphql';
import { Button, Modal, Heading } from '@superops/ui-design-system';
import { GET_SHARED_IT_DOCS_DETAILS } from '@nile/rmm/src/modules/asset-management/Graphql/asset';
import React, { useContext, useEffect, useState } from 'react';
import ITDocsContext from '@nile/rmm/src/modules/common/contexts/ITDocsListContext';
import { SVGIcon } from '@superops/super-icons';
import ShareItDocumentList from '@nile/rmm/src/modules/it-documentation/components/sub-pages/asset-share/share-it-document-list';
import { FormattedMessage } from 'react-intl';

function ShareItDocumentToClients(props) {
  const { assetId, intl, clientId, siteId } = props;
  const [associatedSheetActive, setAssociatedSheetActive] = useState(false);
  const [listLoader, setListLoader] = useState(true);
  const [docsList, setDocsList] = useState([]);
  const context = useContext(ITDocsContext);
  const toggleAssociateAsset = () => {
    setAssociatedSheetActive((prev) => !prev);
    context.setToggleDocumentShare(false);
  };
  const [viewChange, setViewChange] = useState(true);
  const { data: sharedDocList } = useCachedQuery(GET_SHARED_IT_DOCS_DETAILS, {
    client: RMMClient,
    variables: {
      assetId: assetId
    }
  });
  useEffect(() => {
    if (sharedDocList) {
      setDocsList(sharedDocList?.getITDocSharedDetails);
      setListLoader(false);
    }
  }, [sharedDocList]);
  useEffect(() => {
    if (context.toggleDocumentShare) {
      setAssociatedSheetActive(true);
    }
  }, [context.toggleDocumentShare]);

  const reRenderUpdatedData = (updatedDocList) => {
    setDocsList(updatedDocList);
    setViewChange((prev) => !prev);
  };
  return (
    <CardPage
      isNewLayout
      className="f11 white-bg br10 min-height-320"
      tableContent={!!props?.showMonitoredAssets}
      key={assetId}
    >
      <div className="white-to-grey-bg br10">
        <div className="flex p2040 fx-sb divider">
          <Heading element="h2">
            <FormattedMessage id="rmm.itdocument.shared.with" />
          </Heading>
          <AccessControl
            roleToCheck="itDocumentation.edit"
            render={
              <Button
                id="itAssociateAssets"
                icon={<SVGIcon name="Share" size="sm" />}
                onClick={toggleAssociateAsset}
              >
                {getTranslatedText(intl, 'common.share')}
              </Button>
            }
          />
        </div>
        <Modal
          open={associatedSheetActive}
          onClose={toggleAssociateAsset}
          medium
          titleHidden
          title=""
          showCloseButton={false}
        >
          <ShareItDocumentList
            editable
            listLoader={listLoader}
            docsList={docsList}
            toggleAssociateAsset={toggleAssociateAsset}
            clientId={clientId}
            siteId={siteId}
            reRenderUpdatedData={reRenderUpdatedData}
          />
        </Modal>
        <div className="mb20 pl20 pr-20">
          <ShareItDocumentList
            listLoader={listLoader}
            docsList={docsList}
            clientId={clientId}
            siteId={siteId}
            viewChange={viewChange}
            reRenderUpdatedData={reRenderUpdatedData}
          />
        </div>
      </div>
    </CardPage>
  );
}
export default withErrorBoundary(ShareItDocumentToClients);
